import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { hotelSearch, hotelSearchSetFoundTotalHotels, setIsUserInteractedWithHotelList } from '../../../../../store/slices/hotel';
import { hotelSearchRequest, setFoundTotalHotels } from '../../../../../store/slices/tripSearch';

const LoadMoreHotelsButton = ({
  tripId, totalHotels, foundTotalHotels, className,
}) => {
  const dispatch = useDispatch();
  const { hasUserInteractedWithHotelList } = useSelector((state) => state.hotel);

  const handleLoadMoreHotels = () => {
    dispatch(setIsUserInteractedWithHotelList(false));
    if (tripId) {
      dispatch(hotelSearchSetFoundTotalHotels({
        tripId,
        foundTotalHotels: undefined,
      }));
      dispatch(hotelSearch({
        tripId,
        doIgnoreStoredResults: true,
        doShowProgressbar: true,
        searchObj: {
        },
      }));
    } else {
      dispatch(setFoundTotalHotels());
      dispatch(hotelSearchRequest());
    }
  };

  return hasUserInteractedWithHotelList && totalHotels > 0
    && foundTotalHotels > 0 && totalHotels !== foundTotalHotels ? (
      <button className={clsx('banner w-full rounded bg-progressbar text-progressbar p-2 sticky top-0 z-10 mb-2', className)} type="button" onClick={handleLoadMoreHotels}>
        {' '}
        Load More (Found
        {' '}
        {foundTotalHotels}
        {' '}
        Hotels)
      </button>
    ) : <></>;
};

LoadMoreHotelsButton.propTypes = {
  tripId: PropTypes.string,
  totalHotels: PropTypes.number.isRequired,
  foundTotalHotels: PropTypes.number,
  className: PropTypes.string,
};

LoadMoreHotelsButton.defaultProps = {
  tripId: undefined,
  className: undefined,
  foundTotalHotels: undefined,
};

export default LoadMoreHotelsButton;
